"use client";

import { Suspense } from "react";
import { useLoadWhenVisible } from "src/lib/hooks/useLoadWhenVisible";
import { lazyComponent } from "src/lib/LazyModules";
import styles from "./WidgetPreview.module.scss";

/** The examples with a live preview, and which widget each shows. */
const WIDGET_PREVIEW_EXAMPLES = [
  "upload-widget",
  "upload-widget-public",
  "upload-widget-own-api",
  "media-component",
] as const;
export type WidgetPreviewExample = (typeof WIDGET_PREVIEW_EXAMPLES)[number];

const WidgetPreviews = lazyComponent("widgetPreviews", "default");

/**
 * The working widget above its code. Pages render an empty frame of the same height, and the SDK
 * components load only once the example nears the viewport.
 */
export default function WidgetPreview({ example }: { example: WidgetPreviewExample }) {
  const { loadRef, shouldLoad } = useLoadWhenVisible<HTMLDivElement>({ rootMargin: "400px" });
  return (
    <div
      ref={loadRef}
      className={styles.frame}
      data-widget={example === "media-component" ? "media" : "uploader"}
    >
      {shouldLoad ? (
        <Suspense fallback={null}>
          <WidgetPreviews example={example} />
        </Suspense>
      ) : null}
    </div>
  );
}
